module.exports = __webpack_public_path__ + "img/CAN_ORANGE.82d22875.svg";